<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'link'">
    <a
      matTooltip="Перейти к неактивным студентам"
      [matTooltip]="tooltipLabel"
      [class]="'action-btn action-btn-blue' + classNames.join(' ')"
      [routerLink]="link"
      [href]="url"
      [queryParams]="queryParams">
      <mat-icon [ngStyle]="styleIcon">{{ iconName }}</mat-icon>
    </a>
  </ng-container>
  <ng-container *ngSwitchCase="'download'">
    <a
      [href]="url"
      [matTooltip]="tooltipLabel"
      download
      [class]="'action-btn action-btn-blue' + classNames.join(' ')">
      <mat-icon [ngStyle]="styleIcon">{{ iconName }}</mat-icon>
    </a>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <button
      type="button"
      [ngClass]="[
        loading$ ? 'btn-loading spinner' : '',
        'action-btn',
        classNames.join(' ')
      ]"
      [matTooltip]="tooltipLabel"
      [disabled]="disabled"
      (click)="click($event)">
      <mat-icon [ngStyle]="styleIcon">{{ iconName }}</mat-icon>
    </button>
  </ng-container>
</ng-container>
